import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef, OnChanges } from '@angular/core';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { TabModel } from '../../models';
import { LayoutService } from '../../../layout/services/layout.service';
import { Justification } from '../grid/row.component';
import { IconType } from '@shared-features/enums';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class TabComponent implements OnInit, OnChanges {
  @Input() selectedIndex = 0;
  @Input() tabs: TabModel[] = [];
  @Input() disablePagination = false;
  @Output() currentIndex = new EventEmitter<number>();
  @Input() stretchTabs = true;
  @Input() alignTabs: 'start' | 'center' | 'end' = 'center';
  @Input() justify: Justification;
  @Input() backgroundTransparent = false;
  @Input() theme: 'underline' | 'trapezoid' = 'underline';
  @Input() hasBorder:false;

  protected IconType = IconType;

  constructor(public layoutService: LayoutService, private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.currentIndex.emit(this.selectedIndex);
  }

  ngOnChanges(): void {
    this.changeDetector.markForCheck();
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.currentIndex.emit(tabChangeEvent.index);
  }
}
